// Kiểm tra DÙNG CHUNG máy chủ (server/src/hoi-dong.ts) và trang Việc đã làm (nút "Hội đồng"): những điều kiện mà máy chủ CHẮC CHẮN từ chối bằng 400
// thì trang báo ngay bằng đúng câu đó, không gửi yêu cầu (Chromium ghi mọi phản hồi 4xx vào console — hạt khỉ 28/30/34, 12/10/2026).
// Chỉ phụ thuộc kiểu thuần, không import gì → dùng được ở cả hai phía.

/** Phần cấu hình hội đồng mà phép kiểm cần (HoiDong của máy chủ / trang Cài đặt đều thoả). */
export interface CauHinhHoiDongKiem {
  bundleThich: string;
  bundleTraLoi: string;
  bundleBinhLuan: string;
  kbThich?: { mat: boolean } | null;
  kbTraLoi?: { mat: boolean } | null;
  kbBinhLuan?: { mat: boolean } | null;
}

export const LOI_THIEU_CHU = "Bình luận này không kèm nội dung nên không tìm lại được trên trang — nhập đoạn chữ để nhận dạng";

/** Giao thích / trả lời đúng một bình luận cần ít nhất một trong hai kịch bản. Trả câu báo lỗi, hoặc null nếu được. */
export function loiThieuKichBanThichTraLoi(c: CauHinhHoiDongKiem): string | null {
  if (c.bundleThich || c.bundleTraLoi) return null;
  return c.kbThich?.mat || c.kbTraLoi?.mat
    ? "Kịch bản thích/trả lời đã chọn đã bị xoá — vào Cài đặt → Hội đồng nhiều nick để chọn lại"
    : "Chưa chọn kịch bản thích/trả lời trong Cài đặt → Hội đồng nhiều nick";
}

/** Số góc nhìn tối đa một lần giao "nhiều nick cùng vào bài". */
export const MAX_GOC_NHIN = 20;

/** Địa chỉ phải là http(s)://… và không quá 2000 ký tự (cho cả /bai lẫn /binh-luan). Trả câu báo lỗi, hoặc null nếu được. */
export function loiDiaChiHttp(url: unknown): string | null {
  return typeof url === "string" && /^https?:\/\//i.test(url) && url.length <= 2000 ? null : "Cần địa chỉ dạng http(s)://…";
}

/** Chuẩn hoá danh sách góc nhìn đúng như máy chủ: chỉ giữ chuỗi không trống, cắt khoảng trắng, tối đa 200 ký tự mỗi góc. */
export function chuanHoaGocNhin(raw: unknown): string[] {
  return Array.isArray(raw) ? raw.filter((g): g is string => typeof g === "string" && !!g.trim()).map((g) => g.trim().slice(0, 200)) : [];
}

/** Giao nhiều nick cùng vào một bài cần 1..MAX_GOC_NHIN góc nhìn (đã chuẩn hoá). Trả câu báo lỗi, hoặc null nếu được. */
export function loiGocNhinBai(goc: readonly string[]): string | null {
  if (!goc.length) return "Cần ít nhất một góc nhìn cho các nick";
  if (goc.length > MAX_GOC_NHIN) return `Tối đa ${MAX_GOC_NHIN} góc nhìn một lần`;
  return null;
}

/** Giao nhiều nick cùng vào một bài cần kịch bản "bình luận một bài". Trả câu báo lỗi, hoặc null nếu được. */
export function loiThieuKichBanBinhLuanBai(c: CauHinhHoiDongKiem): string | null {
  if (c.bundleBinhLuan) return null;
  return c.kbBinhLuan?.mat
    ? "Kịch bản bình luận một bài đã chọn đã bị xoá — vào Cài đặt → Hội đồng nhiều nick để chọn lại"
    : "Chưa chọn kịch bản bình luận một bài trong Cài đặt → Hội đồng nhiều nick";
}

// ---- Cấu hình hội đồng ở trang Cài đặt (nút Lưu): cùng luật với mergeHoiDong của máy chủ (server/src/hoi-dong.ts) — trang báo ngay, KHÔNG gửi yêu cầu chắc chắn bị 400
// (mỗi 400 là một dòng đỏ trong console; bộ khỉ hạt 125 và 155, 13/10/2026). Test song song server/test/z-hoi-dong-cau-hinh-chung.test.ts giữ hai bên không lệch. ----
export const HD_MAX_NICK = 20, HD_MAX_PHUT = 240, HD_MAX_NGAY = 500;
export interface SoHoiDong { soNickMin: number; soNickMax: number; soTraLoi: number; gianCachMinPhut: number; gianCachMaxPhut: number; maxMoiBotNgay: number }
const soNguyen = (v: unknown, nhan: string, min: number, max: number): string | null =>
  typeof v === "number" && Number.isInteger(v) && v >= min && v <= max ? null : `${nhan} phải là số nguyên từ ${min} đến ${max}`;
/** Câu báo lỗi ĐẦU TIÊN của các số trong cấu hình hội đồng (đúng thứ tự và câu của máy chủ), hoặc null nếu hợp lệ. */
export function loiSoHoiDong(c: SoHoiDong): string | null {
  return soNguyen(c.soNickMin, "Số nick ít nhất mỗi bình luận", 1, HD_MAX_NICK)
    ?? soNguyen(c.soNickMax, "Số nick nhiều nhất mỗi bình luận", 1, HD_MAX_NICK)
    ?? soNguyen(c.soTraLoi, "Số nick trả lời (còn lại chỉ thích)", 0, HD_MAX_NICK)
    ?? soNguyen(c.gianCachMinPhut, "Giãn cách ít nhất (phút)", 1, HD_MAX_PHUT)
    ?? soNguyen(c.gianCachMaxPhut, "Giãn cách nhiều nhất (phút)", 1, HD_MAX_PHUT)
    ?? soNguyen(c.maxMoiBotNgay, "Tối đa lượt hội đồng mỗi nick mỗi ngày", 1, HD_MAX_NGAY)
    ?? (c.soNickMin > c.soNickMax ? "Số nick ít nhất không được lớn hơn số nick nhiều nhất" : null)
    ?? (c.gianCachMinPhut > c.gianCachMaxPhut ? "Giãn cách ít nhất không được lớn hơn giãn cách nhiều nhất" : null)
    ?? (c.soTraLoi > c.soNickMax ? "Số nick trả lời không được lớn hơn số nick nhiều nhất" : null);
}
export const LOI_HD_BAT_CHUA_CHON_KB = "Chọn ít nhất một kịch bản (thích hoặc trả lời) trước khi bật";

// ---- Cấu hình "Tự trả lời bình luận" (reply-scan) ở trang Cài đặt: cùng luật với server/src/reply.ts — kiểm trước khi gửi (hạt khỉ 125: nút Lưu gửi giá trị rỗng/NaN → 400 → dòng đỏ console).
// Test song song server/test/z-hoi-dong-cau-hinh-chung.test.ts giữ hai bên không lệch. ----
export const TS_MIN_EVERY = 15, TS_MAX_EVERY = 24 * 60, TS_MAX_WITHIN = 90, TS_MAX_PLACES = 200, TS_MAX_PER_BOT = 500;
export interface SoTuTraLoi { everyMin: number; withinDays: number; maxPerBotDay: number; maxPlaces: number }
/** Câu báo lỗi ĐẦU TIÊN của các số trong cấu hình tự trả lời (đúng thứ tự và câu của máy chủ), hoặc null nếu hợp lệ. */
export function loiSoTuTraLoi(c: SoTuTraLoi): string | null {
  return soNguyen(c.everyMin, "Quét mỗi (phút)", TS_MIN_EVERY, TS_MAX_EVERY)
    ?? soNguyen(c.withinDays, "Chỉ quét nơi làm trong (ngày)", 1, TS_MAX_WITHIN)
    ?? soNguyen(c.maxPerBotDay, "Tối đa lần trả lời mỗi bot mỗi ngày", 1, TS_MAX_PER_BOT)
    ?? soNguyen(c.maxPlaces, "Tối đa số nơi mỗi lần quét", 1, TS_MAX_PLACES);
}
export const LOI_TS_BAT_CHUA_CHON_KB = "Chọn kịch bản trả lời trước khi bật";
